"use client";
import Icon from "@/components/common/Icon";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui";
import { usePlatformData } from "@/contexts/PlatformDataContext";
import { InvestmentDetails } from "@/components";
import moment from "moment";
import Link from "next/link";
import { useApiQuery } from "@/libs/api/useApiQuery";
import { apiClient } from "@/libs/api/apiHooks";

export default function PackagesHistory() {
  const [platform] = usePlatformData();
  const { data: transactions } = useApiQuery(["getWalletsTransactions"], () =>
    apiClient.getWalletsTransactions({
      queries: {
        take: 99,
        skip: 0,
      },
    }),
  );
  const purchasedItems = platform.investMentPlans?.map(
    ({ userPurchasedCount, weight }) => ({ count: userPurchasedCount, weight }),
  );
  return (
    <>
      <div className="flex justify-center bg-white md:px-18 pb-4 sticky top-0 z-10">
        {purchasedItems?.map(({ count, weight }, k) => (
          <div className="group flex items-center pe-4" key={k}>
            <div className="h-3 [&:not(:last-child)]:border-e [&:not(:last-child)]:border-e-gray-200 me-4 group-first:hidden"></div>
            <span className="text-gray-500 text-base font-medium">
              {weight}
            </span>
            <span className="text-gray-500/50 text-base font-medium">g</span>
            <div className="w-3 border-b border-dashed border-gray-200 mx-2"></div>
            <span className="text-blue-ribbon-500 text-base font-medium">
              x
            </span>
            <span className="text-blue-ribbon-500 text-base font-medium">
              {count}
            </span>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mt-5 px-4 md:px-18 mb-6">
        <Link
          href="/ai-arbitrage/packages"
          className="relative rounded-2xl h-72"
          prefetch={false}
        >
          <div className="absolute start-0 top-0 w-full h-full flex flex-col items-center justify-center gap-0">
            <Icon className="text-white" name="Add" size={40} />
            <span className="text-white text-base font-medium">
              New Package
            </span>
          </div>
          <img
            className="rounded-2xl h-full w-full object-cover object-bottom"
            src="/images/patterns/aurora-breeze.png"
          />
        </Link>
        {transactions?.data?.[0]?.map((item, k) => (
          <div
            key={k}
            className="flex flex-col mx-auto bg-white rounded-2xl shadow px-6 pt-6 pb-2 text-center w-full"
          >
            <div className="flex justify-center mb-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full border border-green-200 bg-green-50 text-green-500">
                <Icon name="TickCircle" size={20} />
              </div>
            </div>
            <h2 className="text-green-600 font-semibold text-lg mb-5">
              Active Package
            </h2>
            <div className="space-y-3 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-500">Amount</span>
                <span className="text-gray-800">{item.amount}gr</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-500">Pack No.</span>
                <span className="text-gray-800">
                  {item.userPurchasedPacks?.length} Pack
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-500">Start Date</span>
                <span className="text-gray-800 font-semibold">
                  {moment(item.completedAt).format("YYYY/MM/DD HH:mm")}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-500">Expired Date</span>
                <span className="text-gray-800 font-semibold">
                  {item.completedAt
                    ? moment(item.completedAt).add("years", 2).format("YYYY")
                    : ""}
                </span>
              </div>
            </div>

            <Dialog>
              <DialogTrigger asChild>
                <button className="text-blue-500 font-medium hover:underline mt-2">
                  See details
                </button>
              </DialogTrigger>
              <DialogContent
                aria-describedby="transaction detail"
                className="max-h-fit w-full max-w-[343px] md:max-w-[360px] lg:max-w-[375px]"
              >
                <InvestmentDetails data={item} />
              </DialogContent>
            </Dialog>
          </div>
        ))}
      </div>
    </>
  );
}
